module.exports = __webpack_public_path__ + "img/svg/xbox-xs.0a7db3be01632ff4a11a1db9e2ac59cb.svg";